export default function (val, showYear = true) {
  val = String(val);

  const regx = /\w+\s(\w+)\s\d+\s(\d+)./;
  if (!showYear) {
    return regx.exec(val)[1];
  }
  return `${regx.exec(val)[1]} ${regx.exec(val)[2]}`;
}
